import React, { Children } from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  onClick,
  type = 'button'
}: ButtonProps) {
  const baseClasses = 'rounded-xl font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantClasses = {
    primary: 'bg-[#F97316] hover:bg-[#EA580C] text-white shadow-sm hover:shadow focus:ring-[#F97316]',
    secondary: 'bg-[#2563EB] hover:bg-[#1D4ED8] text-white shadow-sm hover:shadow focus:ring-[#2563EB]',
    outline: 'border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 focus:ring-[#2563EB]'
  };
  const sizeClasses = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-6 py-3'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} transform hover:scale-105`;
  const handleClick = () => {
    // Check if this is a "Get Your eSIM" button and handle accordingly
    const childrenText = typeof children === 'string' ? children : Children.toArray(children).find(child => typeof child === 'string') as string;
    if (childrenText && childrenText.includes('Get Your eSIM')) {
      // Dispatch a custom event to open the plan selector
      window.dispatchEvent(new CustomEvent('openPlanSelector'));
    }
    // Call the original onClick if provided
    if (onClick) {
      onClick();
    }
  };
  return <button type={type} className={buttonClasses} onClick={handleClick} data-id="element-108">
      {children}
    </button>;
}